import { render } from "./AppointmentDataForm.vue?vue&type=template&id=42b1774a&scoped=true&ts=true"
import script from "./AppointmentDataForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentDataForm.vue?vue&type=script&lang=ts"

import "./AppointmentDataForm.vue?vue&type=style&index=0&id=42b1774a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b1774a"]])

export default __exports__